// extracted by mini-css-extract-plugin
module.exports = {"ChatChannelCard":"ChatChannelListSection_ChatChannelCard__2EGnd"};